const initProviderFilter = () => {
  const providerFilter = document.querySelector('.js-provider-filter');
  const providerList = document.querySelector('.js-provider-list');

  if (!providerFilter || !providerList) { return; }

  const providerItems = providerList.querySelectorAll('.js-provider-item');
  let delaySearch = null;

  if (!providerFilter || !providerList) { return; }

  providerFilter.focus()

  function filterProvider(filter) {
    clearTimeout(delaySearch);
    delaySearch = setTimeout(function () {
      processSearch(filter)
    }, 250);
  }

  function processSearch(filter) {
    var providerCount = 0;
    providerItems.forEach((provider) => {
      var hideThis = provider.innerText.search(new RegExp(filter, 'i')) < 0;
      provider.toggleAttribute("hidden", hideThis)
      providerCount += hideThis ? 0 : 1;
    })
    document.querySelector('.js-number-of-providers').innerText = providerCount;
  }

  providerFilter.addEventListener("input",function (){
    filterProvider(this.value)
  });
};

export { initProviderFilter};
